<!-- <div class="loading" *ngIf="isPageLoading" @fadeOutAnimation>
<div class="spinner-grow indicator" role="status">
  <span class="sr-only">Loading...</span>
</div>
</div> -->
@if (isPageLoading) {
  <div class="loading" @fadeOutAnimation>
    <!--Big blue-->
    <div class="preloader-wrapper active indicator">
      <div class="spinner-layer spinner-client-color">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
        <div class="gap-patch">
          <div class="circle"></div>
        </div>
        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
}

<app-navbar></app-navbar>

<main id="mainContent">
  <div class="container-fluid h-100">
    <router-outlet #outlet="outlet"></router-outlet>
    <app-footer></app-footer>
  </div>
</main>

@if (languageDropdown) {
  <div id="languageDropdown">
    <select id="languageSelect" (change)="changeLanguage($event.target.value)">
      @for (lang of supportedLangs; track lang) {
        <option [value]="lang.code" [selected]="lang.code == currentLangCode.code">
        {{lang.label}}</option>
      }
    </select>
  </div>
}